module.exports = __webpack_public_path__ + "images/canonical-card/subscribe-icon.8d579b9e56640fe5ff62.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/canonical-card/subscribe-icon.svg
// module id = A3gE
// module chunks = 0